import { TemplateData } from './htmlTemplates';

export const neonGlowTemplate = {
  id: 'neon-glow',
  name: '霓虹发光',
  description: '霓虹灯效果，适合夜生活和娱乐内容',
  category: 'entertainment',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: linear-gradient(135deg, #0a0a0a, #1a1a2e, #16213e);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .cover::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 20%, ${data.theme.primaryColor}20 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, ${data.theme.accentColor}20 0%, transparent 50%);
          animation: pulse 4s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 0.8; }
        }

        .brand-neon {
          position: absolute;
          top: 25px;
          right: 25px;
          font-size: 18px;
          color: ${data.theme.accentColor};
          text-shadow: 0 0 10px ${data.theme.accentColor};
          z-index: 2;
        }

        .title {
          font-size: 42px;
          font-weight: 900;
          color: #ffffff;
          text-align: center;
          line-height: 1.1;
          margin-bottom: 25px;
          letter-spacing: -1px;
          position: relative;
          z-index: 2;
          text-shadow: 
            0 0 5px ${data.theme.primaryColor},
            0 0 10px ${data.theme.primaryColor},
            0 0 15px ${data.theme.primaryColor};
        }

        .title-glow {
          color: ${data.theme.primaryColor};
          text-shadow: 
            0 0 5px ${data.theme.primaryColor},
            0 0 10px ${data.theme.primaryColor},
            0 0 15px ${data.theme.primaryColor},
            0 0 20px ${data.theme.primaryColor};
          animation: glow 2s ease-in-out infinite alternate;
        }

        @keyframes glow {
          from {
            text-shadow: 
              0 0 5px ${data.theme.primaryColor},
              0 0 10px ${data.theme.primaryColor},
              0 0 15px ${data.theme.primaryColor};
          }
          to {
            text-shadow: 
              0 0 10px ${data.theme.primaryColor},
              0 0 20px ${data.theme.primaryColor},
              0 0 30px ${data.theme.primaryColor},
              0 0 40px ${data.theme.primaryColor};
          }
        }

        .subtitle {
          font-size: 16px;
          color: #cccccc;
          text-align: center;
          line-height: 1.4;
          font-weight: 300;
          position: relative;
          z-index: 2;
        }

        .neon-box {
          background: transparent;
          border: 2px solid ${data.theme.accentColor};
          color: ${data.theme.accentColor};
          padding: 2px 8px;
          border-radius: 4px;
          font-weight: 500;
          margin: 0 2px;
          box-shadow: 
            0 0 5px ${data.theme.accentColor},
            inset 0 0 5px ${data.theme.accentColor}20;
          animation: neonPulse 3s ease-in-out infinite;
        }

        @keyframes neonPulse {
          0%, 100% {
            box-shadow: 
              0 0 5px ${data.theme.accentColor},
              inset 0 0 5px ${data.theme.accentColor}20;
          }
          50% {
            box-shadow: 
              0 0 15px ${data.theme.accentColor},
              0 0 25px ${data.theme.accentColor}50,
              inset 0 0 10px ${data.theme.accentColor}30;
          }
        }

        .bottom-line {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          width: 150px;
          height: 2px;
          background: linear-gradient(90deg, transparent, ${data.theme.primaryColor}, transparent);
          box-shadow: 0 0 10px ${data.theme.primaryColor};
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="brand-neon">${data.theme.logo}</div>
        <h1 class="title">
          ${data.title.split('').map((char, i) => 
            i % 4 === 0 ? `<span class="title-glow">${char}</span>` : char
          ).join('')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{2,5})/g, '<span class="neon-box">$1</span>')}</p>
        <div class="bottom-line"></div>
      </div>
    </body>
    </html>
  `
};
